import { AITaskModelsApiResponse } from '../types/api-response.type';
import { AITaskModelUpdate } from '../types/ai-task-models.types';
import http from '../utils/http-common';

const getAITaskModels = () => {
  return http.get<AITaskModelsApiResponse>(
    '/admin/configuration/ai-task-models/get'
  );
};

const updateAITaskModels = (tasks: AITaskModelUpdate[]) => {
  return http.post<AITaskModelsApiResponse>(
    '/admin/configuration/ai-task-models/update',
    { tasks }
  );
};

const resetAITaskModel = (taskKey: string) => {
  return http.post<AITaskModelsApiResponse>(
    '/admin/configuration/ai-task-models/reset',
    { taskKey }
  );
};

const AITaskModelsService = {
  getAITaskModels,
  updateAITaskModels,
  resetAITaskModel,
};

export default AITaskModelsService;
